<ng-template #customMonthCellTemplate let-day="day" let-locale="locale">
  <div
    class="flex flex-col justify-between h-full min-h-36 w-full relative p-sm cursor-default">
    <!-- Day Number Row -->
    <div
      class="text-lg font-semibold"
      [class.text-neutral-900]="
        day.date.getTime() !== viewDate().getTime() && day.inMonth
      "
      [class.text-primary-500]="
        day.date.getTime() === viewDate().getTime() && day.inMonth
      "
      [class.text-neutral-300]="
        day.date.getTime() !== viewDate().getTime() && !day.inMonth
      ">
      {{ day.date | calendarDate: 'monthViewDayNumber' : locale }}
    </div>

    <!-- Events list inside the cell -->
    @if (day.events.length > 0) {
      <div class="flex flex-col gap-x-sm w-full">
        @for (event of day.events.slice(0, 3); track event.meta.elementId) {
          <div class="relative" [id]="event.meta.elementId">
            <button
              type="button"
              (click)="eventClick.emit(event)"
              class="flex items-center gap-x-sm rounded px-sm text-xs2 font-semibold text-start w-full text-neutral-900"
              [class.bg-primary-100]="!event.meta.color"
              [class.bg-destructive-100]="
                event.meta.color === CALENDAR_EVENT_COLOR.RED
              "
              [class.bg-neutral-100]="
                event.meta.color === CALENDAR_EVENT_COLOR.GRAY
              "
              [title]="event.title">
              <span
                [class]="
                  'size-1.5 rounded-full shrink-0 ' +
                  (event.meta.color === CALENDAR_EVENT_COLOR.RED
                    ? 'bg-destructive-500'
                    : event.meta.color === CALENDAR_EVENT_COLOR.GRAY
                      ? 'bg-neutral-500'
                      : 'bg-primary-500')
                "></span>
              <span
                class="truncate w-13 md:w-20 lg:w-22 min-[68rem]:w-24 xl:w-28 min-[88rem]:w-30 2xl:w-32 min-[104rem]:w-36 min-[120rem]:w-40 min-[136rem]:w-44 min-[152rem]:w-48 min-[168rem]:w-52">
                {{ event.title }}
              </span>
            </button>

            @if (isSelectedOccurrence(event)) {
              <lib-calendar-event-modal
                (closeEventDetails)="closeEventDetails()"
                [eventActionsTemplate]="eventActionsTemplate()" />
            }
          </div>
        }

        @if (day.events.length > 3) {
          <button
            type="button"
            (click)="setView.emit(CalendarView.Day); onViewDateChange(day.date)"
            class="text-xs font-medium text-primary-600 p-x-sm whitespace-nowrap hover:underline">
            {{
              ('calendar_event_section_see_more_label' | transloco).replace(
                '{count}',
                (day.events.length - 3).toString()
              )
            }}
          </button>
        }
      </div>
    } @else {
      <div class="flex-1"></div>
    }
  </div>
</ng-template>
